module.exports = __webpack_public_path__ + "static/media/Maf_11ImpuestoRosa.99e72cea.jpg";